// Build a clean, title-based download filename, e.g. "Sunday Service – Sep 27" -> "Sunday_Service_Sep_27.mp4"
export const safeVideoFilename = (title, fallback = "video") => {
  const base = (title || fallback).trim().replace(/\.[a-z0-9]{2,4}$/i, "");
  const clean = base
    .replace(/[^a-z0-9]+/gi, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 80) || fallback;
  return `${clean}.mp4`;
};

// Legacy direct-file check (MP4 via the R2 media proxy).
export const isDownloadable = (url) => {
  if (!url) return false;
  const clean = url.split("?")[0].toLowerCase();
  if (clean.endsWith(".m3u8")) return false;
  return clean.endsWith(".mp4") || clean.includes("/media/");
};

// Any ready video with a playback source can be downloaded: uploads are served
// directly from R2; recorded broadcasts (HLS) are remuxed to MP4 on the fly.
export const canDownload = (item) =>
  !!item && (item.status === "ready" || !item.status) && !!item.playback_url;

// Force a download of an MP4 upload with a friendly filename via the ?download= param.
export const buildDownloadUrl = (playbackUrl, apiBase, id, title) => {
  let url = playbackUrl && playbackUrl.startsWith("http") ? playbackUrl : `${apiBase}/media/${id}.mp4`;
  const name = encodeURIComponent(safeVideoFilename(title));
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}download=${name}`;
};

// Item-aware download URL: recordings go through the HLS->MP4 remux endpoint,
// uploads use the R2 media proxy. Both land with the title as the filename.
export const itemDownloadUrl = (item, apiBase) => {
  const name = encodeURIComponent(safeVideoFilename(item.title));
  if (item.kind === "recording") {
    return `${apiBase}/recordings/${item.id}/download?name=${name}`;
  }
  return buildDownloadUrl(item.playback_url, apiBase, item.id, item.title);
};
